import ModalInfo from './ModalInfo';
export default function Modal (props) {
	return (
		<div 
		className="modal py-4 px-8 bg-blue-200"
		style={ props.show ? {visibility: 'visible', opacity: 1} : {visibility: 'hidden', opacity: 0}}
		aria-hidden="true" 
		>
			<ModalInfo active={props.show} />
		</div>
	)
}